<template>
	<div class="contact">
		<div class="information-hr"></div><div class="information-hr2"></div>
		<div class="contact-info">
			<p class="big">您可以通过以下方式联系到我们</p>
			<p>邮箱：tougao@dobest.com</p>
			<p>官方QQ群：679044789</p>
			<p>联系电话：0571 8805 0880 分机号码：3061#</p>
	    </div>
		<div class="information-hr-bottom"></div><div class="information-hr2-bottom"></div>
	</div>
</template>

<script>
	import axios from 'axios'
	export default{
		data(){
			return{
				
			}
		},
		created(){
			this.$store.commit('SET_ISBLUECOLOR', false)
		}
	}
</script>

<style scoped>
	.contact{
		font-size: 16px;
		padding-left: 20px;  height: 500px;
	}
	.inputName{
		width: 420px;
		border-radius: 15px;
		padding: 20px;
		outline: none;
	}
	.area{
		width: 660px;
	}
	.cont{
		display: inline-block;
		vertical-align: top;
		
	}
	.commitFirst{
		width: 322px;
		height: 86px;
		font-size: 33px;
		display: block;
		margin: 80px auto;
	}
	.big{
		font-size: 24px;
	}
	.mid{
		font-size: 20px;
		margin-top: 90px;
	}
	.contact-info{ padding: 15px 0 0 30px; }
</style>


// WEBPACK FOOTER //
// src/views/contact.vue